var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "div",
        { staticClass: "c-map-modal" },
        [
          _c("div", {
            staticClass: "c-map-modal__shadow",
            on: { click: _vm.closeButtonClickHandler }
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "dialog",
                {
                  staticClass: "c-map-modal__body",
                  attrs: {
                    "aria-label": _vm.location.layerName,
                    "aria-modal": _vm.showModal
                  }
                },
                [
                  _vm._t("content"),
                  _vm._v(" "),
                  _vm.location
                    ? _c("div", { staticClass: "c-map-modal__inner" }, [
                        _vm.location.adHocPolygonType
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-map-modal__header c-map-modal__header--border"
                                },
                                [
                                  _c("img", {
                                    staticClass: "c-map-modal__header-icon",
                                    attrs: { src: _vm.location.icon, alt: "" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "c-map-modal__header-content"
                                    },
                                    [
                                      _c(
                                        "h3",
                                        { staticClass: "c-map-modal__title" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.location.layerName) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "c-map-modal__content" },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "c-map-modal__content-title"
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.location.group1Title) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__one"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-map-modal__description",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.location.defaultText
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__two"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "c-map-modal__label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.location.startTitle
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-map-modal__description"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    this.formatDate(
                                                      _vm.location.startDate
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "c-map-modal__label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.location.endTitle
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-map-modal__description"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    this.formatDate(
                                                      _vm.location.endDate
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.location.attachments
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "grid-x grid-margin-x o-columns__one"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cell c-map-modal__cell"
                                            },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "c-map-modal__label"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.location
                                                          .attachmentTitle
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "c-map-modal__description"
                                                },
                                                _vm._l(
                                                  _vm.location.attachments,
                                                  function(attachment) {
                                                    return _c(
                                                      "a",
                                                      {
                                                        key: attachment.index,
                                                        staticClass:
                                                          "c-map-modal__link",
                                                        attrs: {
                                                          href: attachment.url,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            staticClass:
                                                              "c-map-modal__link-icon",
                                                            attrs: {
                                                              focusable:
                                                                "false",
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          },
                                                          [
                                                            _c("use", {
                                                              attrs: {
                                                                "xlink:href":
                                                                  "#pdf"
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              attachment.attachmentName
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass: "c-map-modal__content-title"
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.location.group2Title) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__one"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-map-modal__description",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.location.contactText
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.location.trafficManagement
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-map-modal__header c-map-modal__header--border"
                                },
                                [
                                  _c("img", {
                                    staticClass: "c-map-modal__header-icon",
                                    attrs: { src: _vm.icon.url, alt: "" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "c-map-modal__header-content"
                                    },
                                    [
                                      _c(
                                        "h3",
                                        { staticClass: "c-map-modal__title" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                this.getPriorityTitle(
                                                  _vm.location.worksCategory
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "c-map-modal__strapline"
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.location.address1) +
                                              ", " +
                                              _vm._s(_vm.location.town) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "c-map-modal__content" },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass: "c-map-modal__content-title"
                                    },
                                    [_vm._v(_vm._s(_vm.layer.group1Title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__two"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "c-map-modal__label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.layer
                                                      .trafficControlTitle
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-map-modal__description"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.location
                                                      .trafficManagementDescription
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__two"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "c-map-modal__label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.layer.startTitle)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-map-modal__description"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    this.formatDate(
                                                      _vm.location.startDate
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "c-map-modal__label"
                                            },
                                            [_vm._v(_vm._s(_vm.layer.endTitle))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-map-modal__description"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    this.formatDate(
                                                      _vm.location.endDate
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__one"
                                    },
                                    [
                                      _vm.location.emergencyWorks
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cell c-map-modal__cell"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "c-map-modal__description",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.layer.emergencyWorksText
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass: "c-map-modal__content-title"
                                    },
                                    [_vm._v(_vm._s(_vm.layer.group2Title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__one"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-map-modal__description",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.layer.contactText
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__one"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "c-map-modal__label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.layer.referenceTitle)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-map-modal__description"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.location.worksReference
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.location.incidentType
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-map-modal__header c-map-modal__header--border"
                                },
                                [
                                  _c("img", {
                                    staticClass: "c-map-modal__header-icon",
                                    attrs: { src: _vm.icon.url, alt: "" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "c-map-modal__header-content"
                                    },
                                    [
                                      _c(
                                        "h3",
                                        { staticClass: "c-map-modal__title" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.layer.layerName) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "c-map-modal__content" },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "c-map-modal__content-title"
                                    },
                                    [_vm._v(_vm._s(_vm.layer.group1Title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__one"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-map-modal__description",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.layer.defaultText
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass: "c-map-modal__content-title"
                                    },
                                    [_vm._v(_vm._s(_vm.layer.group2Title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__one"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-map-modal__description",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.layer.contactText
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x o-columns__one"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell c-map-modal__cell"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "c-map-modal__label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.layer.referenceTitle)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-map-modal__description"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.location.rapidReference
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.coastwatch
                          ? _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  { staticClass: "c-map-modal__header" },
                                  [
                                    _vm.desktop
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-map-modal__header-image-container"
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "c-map-modal__header-image",
                                              attrs: {
                                                src: _vm.location.imgSrc,
                                                alt: _vm.location.imgAlt
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.desktop
                                      ? _c("img", {
                                          staticClass:
                                            "c-map-modal__header-icon",
                                          attrs: { src: _vm.icon.url, alt: "" }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-map-modal__header-content"
                                      },
                                      [
                                        _c(
                                          "h3",
                                          { staticClass: "c-map-modal__title" },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.location.name) +
                                                "\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "c-map-modal__subtitle"
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.location.quality) +
                                                "\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.desktop
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "c-map-modal__strapline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(_vm.location.desc) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.desktop
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "c-button",
                                                attrs: {
                                                  target: "_blank",
                                                  href:
                                                    _vm.layer.environmentLink
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.layer
                                                      .environmentLinkTitle
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.desktop
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "c-map-modal__description"
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(_vm.location.desc) +
                                              "\n          "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "c-button",
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.layer.environmentLink
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.layer.environmentLinkTitle
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "MapTabs",
                                  { on: { activeTab: _vm.selectedTab } },
                                  [
                                    _c(
                                      "MapTab",
                                      {
                                        attrs: {
                                          name: "mapSummary",
                                          panelSuffix: "Panel",
                                          tabSuffix: "Tab",
                                          isActive: true,
                                          title: _vm.layer.summaryTitle
                                        },
                                        on: { tabClick: _vm.onTabClick }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "c-map-modal__description"
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.coastwatch.summary.heading
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.spillHistory
                                          ? _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "c-map-modal__heading"
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.coastwatch.summary
                                                        .spillHistoryLabel
                                                    ) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.spillHistory
                                          ? _c(
                                              "div",
                                              { staticClass: "c-map-spill" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-map-spill__list"
                                                  },
                                                  _vm._l(
                                                    _vm.spillHistoryDetails,
                                                    function(item) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: item.index,
                                                          staticClass:
                                                            "c-map-spill__item"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "c-map-spill__item-date"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.date
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "c-map-spill__item-result"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.result
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _vm.coastwatch
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "c-map-modal__description"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.coastwatch
                                                                .summary
                                                                .spillDisclaimerText
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "MapTab",
                                      {
                                        attrs: {
                                          name: "mapInformation",
                                          panelSuffix: "Panel",
                                          tabSuffix: "Tab",
                                          isActive: false,
                                          title: _vm.layer.informationTitle
                                        },
                                        on: { click: _vm.onTabClick }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "c-map-modal__description"
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.coastwatch.information
                                                      .beachStatusText
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "c-map-modal__description",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.coastwatch.information
                                                .informationText
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "MapTab",
                                      {
                                        attrs: {
                                          name: "mapWeather",
                                          panelSuffix: "Panel",
                                          tabSuffix: "Tab",
                                          isActive: false,
                                          title: _vm.layer.weatherTitle
                                        },
                                        on: { click: _vm.onTabClick }
                                      },
                                      [
                                        _vm.weather
                                          ? _c(
                                              "div",
                                              { staticClass: "c-map-weather" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-map-weather__list"
                                                  },
                                                  _vm._l(
                                                    _vm.weatherDetails,
                                                    function(item) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: item.index,
                                                          staticClass:
                                                            "c-map-weather__item"
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "c-map-weather__item-date"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(item.day)
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "c-map-weather__item-icon",
                                                              attrs: {
                                                                "aria-hidden":
                                                                  "true",
                                                                focusable:
                                                                  "false"
                                                              }
                                                            },
                                                            [
                                                              _c("use", {
                                                                attrs: {
                                                                  "xmlns:xlink":
                                                                    "http://www.w3.org/1999/xlink",
                                                                  "xlink:href":
                                                                    item.icon
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "c-map-weather__item-temp"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.temp
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-map-modal__action" }, [
                    _vm.showModal
                      ? _c(
                          "button",
                          {
                            ref: "close",
                            staticClass: "c-button c-button--cover",
                            attrs: { type: "button", tabindex: "0" },
                            on: {
                              click: _vm.closeButtonClickHandler,
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "tab",
                                    9,
                                    $event.key,
                                    "Tab"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onFocusoutClose($event)
                              }
                            }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "c-button__icon",
                                attrs: {
                                  "aria-hidden": "true",
                                  focusable: "false"
                                }
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    "xlink:href": "#map-close"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "visually-hidden" }, [
                              _vm._v("Close modal")
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading ? _c("LoadingSpinner") : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe122c1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe122c1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/layered-map/MapModal.vue
// module id = 670
// module chunks = 0